// extracted by mini-css-extract-plugin
module.exports = {"Hero":"Hero_Hero__1ehKd","heroImage":"Hero_heroImage__1fVWh","lead":"Hero_lead__Ja00q"};